import { TileLink } from '@/new-cars/common/TileLink.styles';
import useTestDriveCenter from '~/hooks/new-cars/useTestDriveCenter';
import toLowerKebabCase from '~/utilities/toLowerKebabCase';
import BrandCardIcon from './BrandCardIcon';

const desktopIconSizes: Record<string, number> = {
  Chrysler: 157,
  Dodge: 197,
  Jeep: 128,
  Ram: 191
};

const mobileIconSizes: Record<string, number> = {
  Chrysler: 127,
  Dodge: 127,
  Jeep: 76,
  Ram: 127
};

type OwnProps = {
  make: string;
};

export default function BrandCard({ make }: OwnProps) {
  const { session } = useTestDriveCenter();
  const desktopSize = desktopIconSizes[make] ?? 128;
  const href = `/new/${toLowerKebabCase(make)}${
    session ? `?session=${session}` : ''
  }`;
  const mobileSize = mobileIconSizes[make] ?? 87;

  return (
    <TileLink
      aria-label={make}
      data-analytics-attributes={JSON.stringify({
        level: 'Brand',
        section: 'Brand',
        text: make
      })}
      data-analytics-id="New Cars"
      data-testid="brand-card"
      href={href}
    >
      <div
        aria-hidden="true"
        className="-mx-xl -my-xl flex h-[92px] items-center justify-center overflow-hidden md:h-[127px]"
      >
        <span className="md:hidden">
          <BrandCardIcon make={make} size={mobileSize} />
        </span>
        <span className="hidden md:inline">
          <BrandCardIcon make={make} size={desktopSize} />
        </span>
      </div>
    </TileLink>
  );
}
